import State from "slotworks/state-machine/states/state";
import Components from "slotworks/components/components";
import gameState from "slotworks/model/game-state";
import G288SpinRecord from "integration/spin-record";
import { parallel } from "slotworks/utils/race-utils";
import Contract from "slotworks/utils/contract";
import { StaticSymbolsCommand } from "slotworks/commands/symbols/static-symbols-command";
import Timer from "slotworks/utils/timer";
import * as TweenJS from "slotworks/utils/tween";
import { RestoreSymbolsCommand, UnlockSymbols } from "commands/symbols-commands";
import { ShakeLayers } from "commands/shake-command";
import Layers from "slotworks/graphics/layers/layers";
import { isBigWinInBaseGame } from "utils/utils";
import { SymbolBehaviourMethod } from "slotworks/components/matrix/symbol/behaviours/symbol-behaviour-driver";
import betModel from "slotworks/model/bets/bet-model";
import WayResult from "integration/builders/way-result";
import soundManager from "slotworks/sound/sound-manager";

export default class StackFeature extends State {

    private skipped: boolean;
    private timer: number;
    private tween: TweenJS.Tween = null;

    private onDisplayComplete: Function;

    public onEnter() {
        this.skipped = false;
        this.timer = Timer.setTimeout(() => this.start(), 200);

        if(isBigWinInBaseGame()) {
            this.tween = ShakeLayers([Layers.MatrixBackground, Layers.MatrixContent, Layers.MatrixForeground, Layers.SymbolAnimations, Layers.Custom.get("StackAddForeground"),
                Layers.Footer, Layers.Custom.get("Animations")], 50, 5, 2, 40);
        }
    }

    public onSkip(cascaded?: boolean) {
        if (this.onDisplayComplete) {
            this.onDisplayComplete();
        }
        StaticSymbolsCommand().then(() => { 
            this.skipped = true;
            Timer.clearTimeout(this.timer);
            if(this.tween) {
                this.tween.stop();
                TweenJS.remove(this.tween)
                this.tween = null;
            }
            this.skip(); 
        });
    }

    public onExit() {
        const record = gameState.getCurrentGame().getCurrentRecord() as G288SpinRecord;
        if(record.creditsWon == 0) {
            if(gameState.getCurrentGame().inFreespinsGame) 
                soundManager.customEvent("freespins_music");
            else
                soundManager.customEvent("base_music");
        }
        if(!record.freespinsTriggered && (gameState.getCurrentGame().inFreespinsGame || !Components.bigWin.isBigWin(record.creditsWon, betModel.getTotalBet()))) {
            RestoreSymbolsCommand(Components.matrix.getAllSymbols());
        }
        super.onExit();
    }

    private start() {
        const record = gameState.getCurrentGame().getCurrentRecord() as G288SpinRecord;
        const symbols = Components.matrix.getGridSymbols().filter(el => el.symbolId == record.stackAddFeatureSymbol || el.symbolId == "WILD");
        const funcs: (() => Contract<void>)[] = [];

        const urlParams = new URLSearchParams(window.location.search);
        const stackParam = urlParams.get("stack");
        const isBigWin = Components.bigWin.isBigWin(record.creditsWon, betModel.getTotalBet());

        if(!isBigWin || gameState.getCurrentGame().inFreespinsGame) {
            if (record.results.length == 1) {
                const result = record.results[0];
                if (result && result instanceof WayResult) {
                    funcs.push(() => Components.celebrateWin.singleTotalWin(record.creditsWon, result));
                }
            } else {
                funcs.push(() => Components.celebrateWin.totalWin(record.creditsWon));
            }
        }

        if(stackParam == "win" || (!stackParam && isBigWin)) {
            for(let symbol of symbols) {
                funcs.push(() => symbol.win());
                funcs.push(() => symbol.stop());
            }
        } else {
            for(let symbol of symbols) {
                funcs.push(() => symbol.stop());
                symbol.executeBehaviour(SymbolBehaviourMethod.Anticipate, true).execute();
            }
        }       
        this.onDisplayComplete = () => {
            this.onDisplayComplete = null;
            Components.celebrateWin.hide();
        };
        parallel(funcs).then(() => { 
            StaticSymbolsCommand().execute();
            if (this.onDisplayComplete) {
                this.onDisplayComplete();
            }
            if(!this.skipped) this.complete(); 
        });
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/states/stack-feature.ts